module.exports = __webpack_public_path__ + "static/media/ic-icon-fix.cf52cd9e.svg";